"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeekDayDate = void 0;
const weekDays = {
    monday: 0,
    tuesday: 1,
    wednesday: 2,
    thursday: 3,
    friday: 4,
    saturday: 5,
    sunday: 6,
};
const getWeekDayDate = (day, target) => {
    const date = target !== null && target !== void 0 ? target : new Date();
    const currentRawDay = date.getDay();
    const currentDay = currentRawDay === 0 ? currentRawDay + 6 : currentRawDay - 1;
    const diff = date.getDate() - currentDay + weekDays[day];
    return new Date(date.setDate(diff));
};
exports.getWeekDayDate = getWeekDayDate;
//# sourceMappingURL=weekDay.js.map